function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchTableau from '@/components/SearchTableau';
import FormMetaReport from '@/modules/tasks/powerbi/components/report/FormMetaReport';
import FormMetaDataset from '@/modules/tasks/powerbi/components/FormMetaDataset.vue';
import PaginationVue from '@/components/PaginationVue';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW } from '@/js/constants';
import BiReportService from '@/apps/data-platform/services/visualization/bi_report_service';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import utils from '@/js/utils';
var NOT_WORKBOOKS = 'There are not workbooks to assign';
export default {
  name: 'ContReportAssignment',
  components: {
    SearchTableau: SearchTableau,
    FormMetaReport: FormMetaReport,
    PaginationVue: PaginationVue,
    FormMetaDataset: FormMetaDataset,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent
  },
  data: function data() {
    return {
      items: [],
      data_ds: {},
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: NOT_WORKBOOKS,
      limit: envConfig.pagintaionSize,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      data_list: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      dataset_ref: {},
      show_dataset: false,
      key_table: 1,
      is_prod_called: false,
      is_dev_called: true,
      dialogFlag: false,
      collapse_filter: false,
      DIALOG_ASSIGN: "DIALOG_ASSIGN",
      key_assign: 1,
      filter_enabled: false // true,
    };
  },
  computed: {
    fields: function fields() {
      return [{
        key: 'object_name',
        label: this.traductor('tablas.report'),
        sortable: true
      }, {
        key: 'data_operator',
        label: this.traductor('tablas.data_operator')
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      {
        key: 'total_datasets',
        label: 'Datasets',
        class: 'text-center'
      }, {
        key: 'total_pages',
        label: this.traductor('tablas.pages'),
        class: 'text-center'
      }, {
        key: 'creation_date',
        label: this.traductor('tablas.creation_time'),
        class: 'text-center'
      }, {
        key: 'action',
        label: this.traductor('tablas.actions'),
        class: 'w-18 text-center'
      }];
    },
    headers: function headers() {
      return [{
        value: 'object_name',
        text: this.traductor('tablas.report'),
        sortable: true
      }, {
        value: 'data_operator',
        text: this.traductor('tablas.data_operator'),
        align: 'center'
      },
      // { key: 'columns.length', label: 'Columns', class: 'text-center' },
      {
        value: 'total_datasets',
        text: 'Datasets',
        class: 'text-center',
        align: 'center'
      }, {
        value: 'total_pages',
        text: this.traductor('tablas.pages'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'creation_date',
        text: this.traductor('tablas.creation_time'),
        class: 'text-center',
        align: 'center'
      }, {
        value: 'action',
        text: this.traductor('tablas.actions'),
        class: 'w-18 text-center',
        align: 'center'
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    },
    isEmptyTable: function isEmptyTable() {
      return !this.items.length;
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    total_datasources: function total_datasources() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var total = 0;
        if (item.columns && item.columns.length) {
          total = new Set(item.columns.map(function (column) {
            return column.datasource_id;
          })).size;
        }
        return total;
      };
    }
  },
  created: function created() {
    this.reloadList();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onReferenceClose: function onReferenceClose() {
      this.show_dataset = false;
    },
    onShowDataset: function onShowDataset(item) {
      var _this = this;
      console.log(item);
      var consulta = {
        dataset_id: item.dataset_id
      };
      BiDatasetService.getDatasetById(consulta).then(function (res) {
        console.log(res);
        if (res.success) {
          _this.dataset_ref = res.data;
          _this.show_dataset = true;
        }
      });
    },
    refreshItem: function refreshItem(item) {
      var index = this.items.findIndex(function (record) {
        return record.workbook_id === item.workbook_id;
      });
      this.$set(this.items, index, item);
    },
    onClickAssign: function onClickAssign(item) {
      var requestData = {
        domain: window.userInfo.domain,
        clauses: {
          document_id: item.id
        }
      };

      /* biDatasetService.assignOperatorReport(requestData).then((req) => {
        if (req.code === 200 && req.success) {
          this.data_ds = req.data.result
          this.title_modal = `WORKBOOK: ${this.data_ds.path_name}/${this.data_ds.object_name}`
          this.$refs['my-modal'].show()
        }
      })*/
      console.log(item);
      this.data_ds = item;
      this.show_dataset = false;
      this.title_modal = "REPORT: ".concat(this.data_ds.path_name, "/").concat(this.data_ds.object_name);
      //this.dialogFlag=true
      this.key_assign += 1;
      this.$refs[this.DIALOG_ASSIGN].onOpen();
      //this.$refs['my-modal'].show()
    },
    processParams: function processParams(params, isProd) {
      var filters = [{
        key: 'environment',
        operator: 'in',
        value: isProd ? [ENVIRONMENT_FLOW.PROD] : [ENVIRONMENT_FLOW.DEV, ENVIRONMENT_FLOW.TEST]
      }];
      if (params && params.clauses) {
        var clauses = params.clauses;
        if (clauses.query_type !== 'advanced') {
          for (var _i = 0, _Object$keys = Object.keys(clauses); _i < _Object$keys.length; _i++) {
            var key = _Object$keys[_i];
            if (clauses[key] && clauses[key].trim()) {
              filters.push({
                key: key,
                operator: '==',
                value: clauses[key].trim()
              });
            }
          }
        }
      }
      return _objectSpread({
        domain: window.userInfo.domain,
        pagination: {
          limit: 10,
          offset: 1
        },
        filters: filters
      }, params);
    },
    reloadList: function reloadList(params, isProd) {
      var _this2 = this;
      this.items = [];
      var defaultParams = this.processParams(params, isProd);
      this.isBusy = true;
      BiReportService.getReports(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this2.items = res.data;
          _this2.data_list = Object.assign([], res.data);
          _this2.pagination.total = res.data.length;
          _this2.pagination.current = 1;
          _this2.messageEmptyList = res.data.length === 0 ? NOT_WORKBOOKS : null;
        } else if (res && res.code === 400) {
          console.warn(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this2.isBusy = false;
      });
    },
    onSearchQuery: function onSearchQuery(data) {
      console.log(data);
      if (data.clauses && data.clauses.environment == 'prod' && !this.is_prod_called) {
        this.is_dev_called = false;
        this.is_prod_called = true;
        this.reloadList({}, true);
      } else if (data.clauses && data.clauses.environment != 'prod' && !this.is_dev_called) {
        this.is_dev_called = true;
        this.is_prod_called = false;
        this.reloadList({}, false);
      } else {
        if (data.clauses) {
          if (data.clauses.query_type == 'advanced') {
            var search = data.clauses.query.toUpperCase();
            this.items = this.data_list.filter(function (x) {
              return x.data_operator.toUpperCase().indexOf(search) != -1 || x.environment.toUpperCase().indexOf(search) != -1 || x.object_name.toUpperCase().indexOf(search) != -1 || x.path_name.toUpperCase().indexOf(search) != -1;
            });
          } else {
            this.items = Object.assign([], this.data_list);
            if (data.clauses.object_name) {
              this.items = this.items.filter(function (x) {
                return x.object_name.toUpperCase().indexOf(data.clauses.object_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.path_name) {
              this.items = this.items.filter(function (x) {
                return x.path_name.toUpperCase().indexOf(data.clauses.path_name.toUpperCase()) != -1;
              });
            }
            if (data.clauses.data_operator) {
              this.items = this.items.filter(function (x) {
                return x.data_operator.toUpperCase().indexOf(data.clauses.data_operator.toUpperCase()) != -1;
              });
            }
            // if (data.clauses.environment)
            //    this.items = this.items.filter(x => x.environment.toUpperCase().indexOf(data.clauses.environment.toUpperCase()) != -1)
          }
        } else {
          this.items = Object.assign([], this.data_list);
        }
        this.pagination.current = 1;
        this.pagination.total = this.items.length;
      }
    },
    onPage: function onPage(page) {
      this.page = page;
      this.reloadList();
    },
    onCloseModal: function onCloseModal(report_id) {
      var _this3 = this;
      if (report_id) {
        var consulta = {
          report_id: report_id
        };
        BiReportService.getReportById(consulta).then(function (res) {
          if (res && res.success) {
            console.log(res);
            var item = _this3.items.find(function (x) {
              return x.report_id == report_id;
            });
            if (item) {
              console.log('found1');
              var index = _this3.items.indexOf(item);
              _this3.items[index] = res.data;
            }
            var item2 = _this3.data_list.find(function (x) {
              return x.report_id == report_id;
            });
            if (item2) {
              console.log('found2');
              var _index = _this3.data_list.indexOf(item2);
              _this3.data_list[_index] = res.data;
            }
            _this3.key_table += 1;
          }
        });
      }
      this.show_dataset = false;
      //this.dialogFlag= false
      this.$refs[this.DIALOG_ASSIGN].onClose();
      //this.$bvModal.hide('my-modal')
    },
    changePagina: function changePagina(pagina) {}
  }
};